import { emailValidator } from "~/core/validators/validators";

export function getEmailFieldLogic() {
  const email = ref("");
  const emailField = ref<any>(null);
  function resetEmailValidation() {
    emailField.value.resetValidation();
  }

  return {
    email,
    emailField,
    emailValidator,
    resetEmailValidation,
  };
}
